<app-header (notifyMobileOpen)="getMobileOpenNotification($event)"></app-header>
<div class="mainContainer">
    <app-menu selectedItem="downloads" class="menu" [class.open]="mobileMenuOpen"></app-menu>
    <div class="content" [class.closed]="mobileMenuOpen">
        <h1>Downloads</h1>

        @for (section of downloads.sections; track section) {
            <div class="gridContainer tileDownloadContainer">
                <h2>
                    {{ section.headline }}
                </h2>
                @for (dl of section.entities; track dl; let i = $index) {
                    <div class="gridContainer tileDownload">
                        <div class="tileContainer">
                            <div class="downloadInfoContainer">
                                <div class="downloadHeadline">{{ dl.headline }}</div>
                                <div class="downloadDescription">{{ dl.description }}</div>
                            </div>
                            <div class="downloadLink">
                                <a class="fileMetaData" title="Datei herunterladen" target="_blank" (click)="downloadEntity(dl)">
                                    <!-- Bei Dateien > 1 MB muss hier eine Unterscheidung rein -->
                                    <span>{{ dl.type }}</span>&nbsp;<span>({{ dl.fileSize | bytes2Kilo }} KB)</span>
                                </a>
                            </div>
                        </div>
                    </div>
                }
            </div>
        }
    </div>
</div>
